import { render, staticRenderFns } from "./notifications_component.vue?vue&type=template&id=79ff445c"
import script from "./notifications_component.vue?vue&type=script&lang=js"
export * from "./notifications_component.vue?vue&type=script&lang=js"
import style0 from "./notifications_component.vue?vue&type=style&index=0&id=79ff445c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports